<template lang="pug">
.SeguimientoReclamo
  #sidebar
    .map-info(v-if="project")
      .map-info-header(ref="header" :style="getBackgroundColorPropertyStyle(project.color)")
        i.project-number.ap-circle-double(:class="project.number > 9 ? 'gt9':''")
          span(:style="getColorPropertyStyle(project, true)") {{project.number}}
        h2(:class="getTitleClass(project.name)") {{project.name}}
        i.close.material-icons(@click="close($event)") clear
      .div-aux-to-fixed-header(:style="getBackgroundColorPropertyStyle(project.color)")
      .map-info-body(ref="body")
        md-card.viewport(v-if="issue")
          md-card-header
            md-content.md-elevation-2
              span.asu-title {{issue.subject}}
          md-card-content
            md-list.md-double-line
              md-list-item
                strong.md-list-item-text Proyecto
                span.md-list-item-text {{issue.project.name}}
              md-list-item
                strong.md-list-item-text Estado
                span.md-list-item-text {{issue.status.name}}
              md-list-item
                strong.md-list-item-text Fecha del Mensaje
                span.md-list-item-text {{issue.start_date}}
              md-divider
              md-subheader(v-if="issue.attachments[0]")
                strong.asu-title Adjuntos
              md-list-item(v-for="(item, index) in issue.attachments" :key="item.content_url")
                md-list-item
                  DownloadButton.material-icons-button(:href="`${item.content_url}?key=${API_KEY}`" type="download" :color="project.color")
                  span.md-list-item-text {{ item.filename }}
              md-divider
              md-subheader
                strong.asu-title Mensaje
              md-list-item
                span.md-list-item-text {{issue.description}}
              md-divider
              div(v-if="issue.journals && issue.journals.length")
                md-subheader
                  strong.asu-title Respuesta
                .md-layout
                  .md-layout-item(:key="journal.created_on" v-for="journal in issue.journals")
                    strong Actualizado por el encargado {{journal.user.name}} {{fromNow(journal.created_on)}}
                    //- md-list(v-if="journal.details && journal.details.length")
                    //-   .md-layout-item(:key="item.created_on" v-for="item in journal.details")
                    //-     span(v-if="item.name === 'done_ratio'") Porcentaje Realizado
                    //-     span(v-if="item.name === 'status_id'") El estado
                    //-     span ha cambiado de {{item.old_value}} a {{item.new_value}}
                    .md-layout-item(v-if="journal.notes")
                      strong Notas:
                      span.md-list-item-text {{journal.notes}}
                    md-divider
  l-map(ref='map' style='min-height: 100vmin; min-height: 100vh;' :bounds="globalBounds" :options="{ zoomControl: false }")
    //- l-control-zoom(position="topleft" style="top: 100px;")
    l-tile-layer(
        v-for="({ url, attribution, visible, name }) in layers"
        :url="url"
        :attribution="attribution"
        :visible="visible"
        :key="`tile-layer-${name}`"
      )
    l-marker(
        v-if="project"
        :lat-lng="getMarkerLanLng()"
        :icon="buildIcon(project)"
        @click="showDetail({ openUp: true })"
      )
      l-tooltip(:content="popupProject(project)")
    l-geo-json(
      v-if="project"
      :geojson="project.geoJson"
      :options="options"
      :options-style="styleFunction"
    )
  Footer
</template>

<script>
import L from 'leaflet'
import { mapGetters } from 'vuex'
import es from 'date-fns/locale/es'
import { distanceInWordsToNow } from 'date-fns'
import { getData } from '@/utils/object.js'
import { hasValue } from '@/utils/array.js'
import mapMixin from '@/mixins/map.js'
import colorPropertyMixin from '@/mixins/color-property.js'
import RedmineService from '@/services/redmine-gateway.js'
import ProjectService from '@/services/projects.js'

let map

export default {
  mixins: [ colorPropertyMixin, mapMixin ],
  mounted () {
    map = this.$refs.map.mapObject
    this.sidebar = L.control.sidebar('sidebar', {
      position: 'right',
      autoPan: true
    })
    map.addControl(this.sidebar)

    const uuid = this.$route.params.uuid
    const projectId = this.$route.params.projectId
    RedmineService.getIssueByUUID(this.$http, projectId, uuid)
      .then(data => {
        this.issue = data
      }).catch(err => {
        console.error(err)
      })
  },
  data () {
    const self = this
    return {
      issue: null,
      project: null,
      projectsWithGeoJson: null,
      latLngShape: { lng: 0, lat: 0 },
      API_KEY: 'f9e76da29eba669129bc01ffee085e744650e3dd',
      options: {
        filter: (feature, layer) => feature.geometry,
        onEachFeature (feature, layer) {
          self.latLngShape = layer.getBounds().getCenter()
          layer.on('click', event => self.showDetail({ openUp: true, detail: feature.properties }))
        }
      }
    }
  },
  methods: {
    fromNow (date) {
      return distanceInWordsToNow(date, { locale: es })
    },
    buildIcon ({ color, number }) {
      return L.divIcon({
        className: `makerIcon`,
        html:
        `<div class="icon-classify project-${number} ap-pin ${number > 9 ? 'gt9' : ''}" style="color: ${color}; font-size: 50px">
          <span class="project-status project-number">${number}</span>
        </div>`,
        iconSize: [50, 50]
      })
    },
    popupProject (project) {
      return `
        <h3>${getData(project).name}</h3>
      `
    },
    getTitleClass (name) {
      return name ? name.length > 20 ? 'gt20' : '' : ''
    },
    styleFunction (feature) {
      const { color, opacity, lineType } = feature.properties
      return {
        color,
        dashArray: lineType || '1',
        fillColor: color || '#fff',
        fillOpacity: opacity || 0.5
      }
    },
    showDetail ({ openUp }) {
      if (openUp) {
        this.sidebar.show()
      } else {
        this.sidebar.hide()
      }
    },
    close () {
      this.showDetail({ openUp: false })
    },
    getMarkerLanLng () {
      // Cuando los issues posean su propia latitud y longitud descomentar el código de abajo
      // if (this.issue && (this.issue.latitude || this.issue.longitude)) return [this.issue.latitude, this.issue.longitude]
      return this.projectMarkerLatLng
    },
    getProjectData () {
      if (!(this.issue && this.issue.project)) return
      if (!hasValue(getData(this.projectsWithGeoJson).projects)) return
      const proj = getData(this.projectsWithGeoJson.projects.find(p => p.id === this.issue.project.id))
      this.project = proj
      this.sidebar.show()
      this.setGlobalBounds()
    }
  },
  computed: {
    ...mapGetters(['dataWithShapes']),
    projectMarkerLatLng () {
      if (this.project && this.latLngShape) {
        return ProjectService.getMarkerPositionByLatLng(this.project, this.latLngShape)
      }
      return { lng: 0, lat: 0 }
    }
  },
  watch: {
    issue () {
      this.getProjectData()
    },
    dataWithShapes (promise) {
      promise.then(data => {
        this.projectsWithGeoJson = data
      })
    },
    projectsWithGeoJson () {
      this.getProjectData()
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'
@import '~@/styles/map/map-scoped'
@import '~@/styles/map/map-info-header-scoped'

.card-container
  margin-top: $f100px
.md-content
  padding: 16px
.map-info-header
  height: $f80px

</style>
